import { useQuery } from "@tanstack/react-query";
import { getAllTypeOfMonths } from "../../../../api/agencyAdmin/bonus";


const useAdvanced = () => {

    const getAllTypeOfMonthsQuery = useQuery({
        queryKey: ["load data get all months query"],
        queryFn: () => getAllTypeOfMonths({
        }),
        select: (res) => {
            console.log({ res });

            if (res
            ) {

                let data = []
                return res
                    ?.map((item) => ({
                        label: item?.name,
                        value: item?.name + '',


                    }))
                return data
                // return res?.users
                //     .map((item) => ({
                //         label: item,
                //         value: item,
                //     }))
            } else {
                return []
            }
        }

    });

    return {
        getAllTypeOfMonthsQuery
    };
}

export default useAdvanced;
